var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDeleteBin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3416 4.00985L14.6749 4.00277L14.6777 5.3361L13.3444 5.33893L13.3628 14.0056C13.3636 14.3738 13.0658 14.6729 12.6976 14.6737L3.36425 14.6935C2.99606 14.6943 2.69695 14.3964 2.69616 14.0282L2.67776 5.36158L1.34443 5.36441L1.3416 4.03108L4.67493 4.024L4.67068 2.02401C4.6699 1.65582 4.96774 1.35671 5.33593 1.35593L10.6692 1.3446C11.0374 1.34382 11.3365 1.64166 11.3373 2.00985L11.3416 4.00985ZM12.0111 5.34176L4.01109 5.35875L4.02808 13.3587L12.0281 13.3417L12.0111 5.34176ZM8.96237 9.34804L10.1434 10.5241L9.20261 11.4689L8.02158 10.2928L6.84555 11.4739L5.90076 10.5331L7.07678 9.35205L5.89576 8.17609L6.83654 7.23129L8.01757 8.40725L9.1936 7.22628L10.1384 8.16708L8.96237 9.34804ZM6.00542 2.68784L6.00826 4.02117L10.0082 4.01268L10.0054 2.67935L6.00542 2.68784Z",
    fill: "#D92D20"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteBin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DeleteBin.53e7597a.svg";
export { ForwardRef as ReactComponent };